<template>
<el-dialog v-model="showDialog" :title="activeTab === 'login' ? '登录' : '注册'" width="400px" :close-on-click-modal="false" @close="handleDialogClose">
    <div class="auth-container">
      <el-tabs v-model="activeTab" stretch>
        <el-tab-pane label="登录" name="login">
          <el-form :model="loginForm" ref="loginFormRef" label-width="0" class="custom-form">
            <el-form-item prop="account">
              <el-input v-model="loginForm.username" placeholder="请输入手机号/邮箱" class="custom-input" />
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" type="password" :show-password="true" placeholder="请输入登录密码" class="custom-input" />
            </el-form-item>
            <el-form-item>
              <SliderCaptcha v-model="loginSliderPassed" ref="sliderCaptchaLoginRef"  />
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="loginForm.remember" class="custom-checkbox">下次自动登录</el-checkbox>
              <a class="forgot-link" href="javascript:void(0)">忘记密码</a>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loginSubmit" :disabled="!loginSliderPassed" class="custom-btn main">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="other-login">
            <div class="other-login-title">其他登录方式</div>
            <div class="other-login-icon">
              <i class="el-icon-mobile-phone"></i>
            </div>
            <div class="other-login-tip" @click="activeTab = 'register'">手机号登录/注册</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="注册" name="register">
          <el-form :model="form" ref="formRef" label-width="0" class="custom-form">
            <el-form-item prop="phone">
              <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号" class="custom-input" />
            </el-form-item>
            <el-form-item>
              <SliderCaptcha v-model="sliderPassed" ref="sliderCaptchaRef" />
            </el-form-item>
            <!-- <el-form-item prop="smsCode">
              <el-input v-model="form.smsCode" maxlength="6" placeholder="请输入短信验证码" class="custom-input short" />
              <el-button :disabled="!sliderPassed || smsCountdown > 0" @click="getSmsCode" class="custom-btn short">
                {{ smsCountdown > 0 ? smsCountdown + 's' : '获取验证码' }}
              </el-button>
            </el-form-item> -->
            <el-form-item prop="password">
              <el-input v-model="form.password" type="password" placeholder="请设置密码" :show-password="true" class="custom-input" />
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="form.agreement" class="custom-checkbox">
                我同意
              </el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submit" :disabled="!sliderPassed" class="custom-btn main">注册</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, reactive, watch } from 'vue'
import SliderCaptcha from '@/components/common/SliderCaptcha.vue'
import { ElMessage } from 'element-plus'
import { sendCode, register } from '@/api/auth'
import { useUserStore } from '@/stores/user'
import type { LoginForm, RegisterForm } from '@/types/user'



const userStore = useUserStore()
const sliderCaptchaRef = ref()
const sliderCaptchaLoginRef = ref()

const props = defineProps({
  modelValue: Boolean
})
const emit = defineEmits(['update:modelValue'])
const showDialog = ref(props.modelValue)
watch(() => props.modelValue, val => showDialog.value = val)

watch(showDialog, val => {
  emit('update:modelValue', val)
})

const resetRegisterForm = () => {
  form.phone = ''
  form.smsCode = ''
  form.password = ''
  form.agreement = false
  sliderPassed.value = false
  sliderCaptchaRef.value?.reset()
  smsCountdown.value = 0
  if (smsTimer) {
    clearInterval(smsTimer)
    smsTimer = null
  }
}

const resetLoginForm = () => {
  loginForm.username = ''
  loginForm.password = ''
  loginForm.remember = false
  loginSliderPassed.value = false
  sliderCaptchaLoginRef.value?.reset()
}

const handleDialogClose = () => {
  resetRegisterForm()
  resetLoginForm()
}

const activeTab = ref('login')

// 登录表单
const loginForm = reactive<LoginForm>({
  username: '',
  password: '',
  remember: false,
})

// 注册表单
const form = reactive<RegisterForm>({
  phone: '',
  smsCode: '',
  password: '',
  agreement: false
})

const loginFormRef = ref()
const loginSliderPassed = ref(false)

const loginSubmit = async () => {
  if (!loginForm.username || !loginForm.password) {
    ElMessage.warning('请输入账号和密码')
    return
  }
  if (!loginSliderPassed.value) {
    ElMessage.warning('请先通过滑块验证')
    return
  }
  try {
    const flag = await userStore.login(loginForm)
    if(flag === false) {
      ElMessage.error('登录失败，请检查账号或密码')
      return
    }
    showDialog.value = false
    resetLoginForm()
  } catch (error) {
    console.error('登录失败:', error)
  }
  ElMessage.success('登录成功')
}


const formRef = ref()
const sliderPassed = ref(false)
const smsCountdown = ref(0)
let smsTimer: any | null = null

const getSmsCode = async () => {
  if (!form.phone) {
    ElMessage.warning('请输入手机号')
    return
  }
  try {
    const res = await sendCode(form.phone || '')
    if (res.data.code === 200) {
      ElMessage.success('验证码已发送')
      smsCountdown.value = 60
      smsTimer = setInterval(() => {
        smsCountdown.value--
        if (smsCountdown.value <= 0) clearInterval(smsTimer)
      }, 1000)
    } else {
      ElMessage.error('发送失败')
    }
  } catch (error) {
    ElMessage.error('发送验证码失败')
    console.error('发送验证码错误:', error)
  }
}

const submit = async () => {
  // if (!form.phone || !form.smsCode || !form.password) {
  //   ElMessage.warning('请填写完整信息')
  //   return
  // }
  //先不需要短信验证码
  if (!form.phone  || !form.password) {
    ElMessage.warning('请填写完整信息')
    return
  }
  if (!form.agreement) {
    ElMessage.warning('请先同意协议')
    return
  }
  // 注册时一并校验验证码
  try {
    const res = await register(form)
    if (res.data.code === 200) {
      ElMessage.success('注册成功')
      resetRegisterForm()
      activeTab.value = 'login' // 切换到登录页面
    } else {
      ElMessage.error(res.data.msg || '注册失败')
    }
  } catch (error) {
    ElMessage.error('注册失败')
  }
}

</script>

<style scoped>
.auth-container {
  max-width: 360px;
  margin: 0 auto;
  padding: 32px 0 0 0;
  background: #fff;
  border-radius: 12px;
}
.custom-form {
  width: 100%;
}
.custom-input {
  width: 100%;
  height: 40px;
  font-size: 15px;
  border-radius: 6px;
}
.custom-input.short {
  width: 140px;
}
.custom-btn {
  height: 40px;
  font-size: 15px;
  border-radius: 6px;
}
.custom-btn.short {
  width: 120px;
  margin-left: 8px;
}
.custom-btn.main {
  width: 100%;
  font-size: 17px;
  margin-top: 8px;
}
.custom-checkbox {
  font-size: 13px;
  color: #666;
}
.form-tip {
  font-size: 12px;
  color: #888;
  margin-top: 12px;
  text-align: center;
}
.slider-captcha-container {
  width: 100%;
  margin: 0 auto 12px auto;
  user-select: none;
}
.slider-track {
  position: relative;
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  border-radius: 6px;
  border: 1.5px solid #e0e0e0;
  overflow: hidden;
  transition: border-color 0.3s, background 0.3s;
}
.slider-track.slider-success {
  border-color: #52c41a;
  background: #52c41a;
}
.slider-track.slider-active:not(.slider-success) {
  background: linear-gradient(90deg, #b7eb8f 0%, #f5f5f5 100%);
}
.slider-thumb {
  position: absolute;
  top: 0;
  width: 40px;
  height: 40px;
  background: #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(36,198,220,0.08);
  color: #666;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.3s ease;
  user-select: none;
  transform: translateX(0);
}
.slider-thumb svg {
  transition: transform 0.3s ease;
}
.slider-thumb.slider-thumb-dragging svg {
  transform: rotate(180deg);
}
.slider-thumb-success {
  background: #52c41a !important;
  color: #fff;
}
.slider-text {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #888;
  font-size: 15px;
  z-index: 1;
  pointer-events: none;
  transition: color 0.3s;
}
.slider-text-success {
  color: #fff;
  font-weight: bold;
}
.other-login {
  margin: 24px 0 0 0;
  text-align: center;
}
.other-login-title {
  color: #bbb;
  font-size: 14px;
  margin-bottom: 8px;
  position: relative;
}
.other-login-title:before, .other-login-title:after {
  content: '';
  display: inline-block;
  width: 60px;
  height: 1px;
  background: #eee;
  vertical-align: middle;
  margin: 0 8px;
}
.other-login-icon {
  margin: 8px 0 4px 0;
  font-size: 32px;
  color: #409eff;
}
.other-login-tip {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
  margin-top: 4px;
}
.forgot-link {
  float: right;
  color: #409eff;
  font-size: 13px;
  margin-left: auto;
  text-decoration: none;
}
</style>
